import type { DocumentsDownloadButtonProps } from "./documents-download-button.type";

import { Flex } from "antd";

import { DocumentDownloadButton } from "@/modules/document/document-download-button";

export const DocumentsDownloadButton = ({
  documents,
  loading,
}: DocumentsDownloadButtonProps) => {
  if (!documents?.length) return null;

  return (
    <Flex vertical align="start" gap="small">
      {documents.map((document) => (
        <DocumentDownloadButton
          key={document.id}
          document={document}
          loading={loading}
        />
      ))}
    </Flex>
  );
};
